import { Grid } from '@material-ui/core';
import { useScrollButtonState } from '@ncr-retail/hooks';
import { HORIZONTAL } from '@ncr-retail/hooks/build/useScrollButtonState/useScrollButtonState';
import React from 'react';
import Pagination from 'src/pagination/pagination';
import { styles } from './tare-weight-percentage-styles';
import { ScrollOrientation } from 'src/common/enumerations/scroll-orientation';
import TareWeightPercentage from './tare-weight-percentage';

interface ITareWeightPercentageForm {
  tarePercentage: number[] | undefined;
  handleSelection: (tareValue: number) => void;
}

export const TareWeightPercentageForm = (props: ITareWeightPercentageForm): JSX.Element => {
  const classes = styles();

  const [
    { currentPage, lastPage, onPageChanged, navScrollLeftEnabled, navScrollRightEnabled },
    scrollRef,
  ] = useScrollButtonState(props.tarePercentage?.length, false, HORIZONTAL);
  return (
    <Grid container className={`${classes.tareWeightBox} ${classes.gridContainerSpacing}`}>
      <Grid container xs={12}>
        <Grid
          container
          ref={scrollRef}
          spacing={2}
          item
          xs={11}
          className={`horizontalScroll ${classes.containerSpacing} ${classes.percentageContainer}`}
          data-testid='tare-weight-percentage-list'
        >
          {props.tarePercentage?.map(
            (item): JSX.Element => (
              <TareWeightPercentage
                key={item}
                tarePercentage={item}
                handleSelection={props.handleSelection}
              />
            ),
          )}
        </Grid>
        <Grid item container xs={1} className={classes.pagination}>
          <Pagination
            currentPage={currentPage}
            totalPages={lastPage}
            updateCurrentPageHandler={onPageChanged}
            testIdPrefix={'tare-weight-percentage'}
            displayText={false}
            canScrollUp={navScrollLeftEnabled}
            canScrollDown={navScrollRightEnabled}
            scrollOrientation={ScrollOrientation.Horizontal}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
